import { render } from "./candidate-form.vue?vue&type=template&id=0c13da68&scoped=true"
import script from "./candidate-form.vue?vue&type=script&lang=js"
export * from "./candidate-form.vue?vue&type=script&lang=js"

import "./candidate-form.vue?vue&type=style&index=0&id=0c13da68&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c13da68"]])

export default __exports__